import { useState} from "react";
import sampleWork from "../../../../assets/img/sample/image 23.png";
import panImage from "../../../../assets/img/sample/pan.png";
import { Modal } from "react-bootstrap";
import { rateMsg, statusObj, getImageUrl, isImage, ratesTooltip} from "../../../../utils";
import { useSelector } from "react-redux";
import ToolTip from "../../../../components/common/Tooltip";

const ServiceDetails  = ({service}) => {
    const [fullScreen, setFullScreen] = useState({show: false, url: '', type: 'image'});;
    const skillsData = useSelector(state => state.Skills);

    const handleFullScreen = (e, url = "", type = 'image') => {
        if(type === 'image') {
            if(isImage(url)) {
                setFullScreen({url: url, show: true, type})
            } else {
                window.open(url)
            }
            
        } else {
            setFullScreen({url: url, show: true, type})
        }
    }

    const showRates = ["Book Cover Design", "Graphics & Design"].indexOf(service.serviceOfferedId.serviceName) > -1;
    const showLevelRates = ["Book Cover Design",  "Graphics & Design", "Copy Editing"].indexOf(service.serviceOfferedId.serviceName) > -1 ;    
    const renderSamples = () => {
        return service.samples.map((sample, index) => {
            return index < 1 ? (
                <div key={sample.uploadSamples} className="imgWrap mt-1">
                    {sample.uploadSamples ? (
                        <>
                        <div className="imgWrap-opt">
                            <a>
                                <b data-bs-toggle="modal" data-bs-target={"#sampleViewModal" + service._id} className="icon-fullscreen" onClick={(e) => handleFullScreen(e, sample.uploadSamples)} />
                            </a>
                        </div>
                        <img src={getImageUrl(sample.uploadSamples)} alt="#" />
                        </>
                    ) : (
                        <div class="urlWrap">
                            <b class="icon-link urlWrap-icon"></b>
                            <p class="urlWrap-url">{sample.url}</p>
                            <div class="urlWrap-opt">
                            <a
                                data-bs-toggle="modal" data-bs-target={"#sampleViewModal" + service._id}
                                onClick={(e) => handleFullScreen(e, sample.url, "url")}
                            >
                                <b class="icon-fullscreen"></b>
                            </a>
                        </div>
                    </div>
                    )}
                </div>

            ) : null
        })
    }

    const workUrls = () => {
        return service.samples.filter(a => a.url).map((sample, index) => {
            return(
                <div key={sample.url} className="col-6">
                    <div className="urlWrap">
                        <b className="icon-link urlWrap-icon" />
                        <p className="urlWrap-url">{sample.url}</p>
                        <div className="urlWrap-opt" onClick={(e) => handleFullScreen(e, sample.url, 'url')}>
                            <a><b className="icon-fullscreen"></b></a>
                        </div>
                    </div>
                </div>
            )
        })
    }
    
    const popupSamples = () => {
        return service.samples.filter(a => a.uploadSamples).map(sample => {
            return(
                <div className="col-6" key={sample.uploadSamples}>
                    <div className="imgWrap">
                        <div className="imgWrap-opt">
                            <a>
                                <b className="icon-fullscreen" onClick={(e) => handleFullScreen(e, sample.uploadSamples)} />
                            </a>
                        </div>
                        <img src={getImageUrl(sample.uploadSamples)} alt="#" />
                    </div>
                </div>
            )
        })
    }
    
    const isRateChecked = (type = '') => {
        let isChecked = false;
        const rates = service?.[type] || [];
        rates.map(rateRec => {
            if(rateRec.level.min > 0 || rateRec.level.max) {
                isChecked = true;
            }
        })
        return isChecked;
    }

    const graphicsTitle = {
        1: "Single Colour",
        2: "Two Colour",
        3: "Multi Colour"
    }


    const renderWorkSamples = () => {
        return(
            <div className="anotherService-col">
                <h2 className="mb-1 titleText">My Sample Work </h2>
                <div className="sampleUpload mt-3">
                    <div className="sampleUpload-file">
                        {renderSamples()}
                    </div>
                    {
                        service.samples.length > 1 && (
                            <div className="sampleUpload-more">
                                <a data-bs-toggle="modal" data-bs-target={"#sampleViewModal" + service._id}>
                                    {(service.samples?.length > 1) ? `+${service.samples?.length - 1}` : ''  }
                                </a>
                                <small>
                                    <span>
                                    <b className="icon-fullscreen" />
                                    </span>
                                    Click this button to enlarge the image
                                </small>
                            </div>
                        )
                    }
                    {
                        service.samples.length < 1 && (
                            <small>
                                No work samples found.
                            </small>
                        )
                    }
                </div>
            </div>
        )
    }

    const isCopyEditing = ["Copy Editing"].indexOf(service.serviceOfferedId.serviceName) > -1;
    const getTitle = (LevelNum = 1) => {
        return isCopyEditing ? `Level ${LevelNum}` : graphicsTitle[LevelNum];
    }

    const rateRecords = (type = 'rates') => {
        return service?.[type]?.map(rateCard => {
            const isChecked = rateCard.level.min != null || rateCard.level.max != null;
            return(
                <li key={rateCard.levelNumber}>
                    <div className="rateLevel">
                        <div className="rateCheck d-inline-flex">
                        {" "}
                        <label className="styledCheck">
                            <input type="checkbox" checked={isChecked} disabled />
                            <span>{getTitle(rateCard.levelNumber)}</span>
                        </label>
                        {
                            isCopyEditing && (
                                <ToolTip placement="top" toolTipMessage={ratesTooltip(rateCard.levelNumber)}>
                                    <a className="infoMark">i</a>
                                </ToolTip>
                            )
                        }
                        </div>
                        <div className="minMax">
                        <div className="minMax-col">
                            <label>₹ Minimum</label>
                            <input type="number" defaultValue={rateCard.level.min} checked disabled/>
                        </div>
                        <div className="minMax-dash">-</div>
                        <div className="minMax-col">
                            <label>₹ Maximum</label>
                            <input type="number" defaultValue={rateCard.level.max} disabled />
                        </div>
                        </div>
                    </div>
                </li>
            )
        })
    }
    
    const isOthers = (service.serviceOfferedId?.serviceName === "Others" && service?.requestForOtherServiceId?.text) ? service?.requestForOtherServiceId?.text : null;
    return(
        <>
            <div key={service._id} className="boxCover noStyle pt-0 mb-5">
                <div className="fieldSet border-0 w-90">
                <ul>
                    <li>
                    <div className="fieldWrap mb-3">
                        <label className="labelForm">Service Offered*</label>
                        <div>
                          <p className="fieldForm">{service?.serviceOfferedId?.serviceName}</p>
                        </div>
                        {
                            
                            isOthers && <div className="mt-2 other-text position-relative verify-link"><p className="fieldForm redBg">{isOthers}</p><div className="input_post link" dangerouslySetInnerHTML={{__html:`<small class="labelBadge">${statusObj[service.requestForOtherServiceId.status]}</small>` }}/></div>
                        }
                    </div>
                    </li>
                    <li>
                    <div className="fieldWrap mb-3 ">
                        <label className="labelForm">Work Experience*</label>
                        <div>
                        <p className="fieldForm preview_experience_section">{service.experience} years</p>
                        </div>
                    </div>
                    </li>
                    {
                        service.pancardNumber && (
                            <li>
                                <div className="fieldWrap mb-3">
                                    <label className="labelForm">
                                    PAN Card Number* 
                                    {/* <small className="labelBadge">Mandatory</small> */}
                                    </label>
                                    <div>
                                    <p className="fieldForm">{service.pancardNumber}</p>
                                    </div>
                                </div>
                            </li>
                        )
                    }
                    {
                        service.GSTNumber && (
                            <li>
                                <div className="fieldWrap mb-3">
                                    <label className="labelForm">
                                    GST Number 
                                    {/* <small className="labelBadge">Optional</small> */}
                                    </label>
                                    <div>
                                    <p className="fieldForm">{service.GSTNumber}</p>
                                    </div>
                                </div>
                            </li>
                        )                        
                    }

                    {
                        service.uploadPancard && (
                            <li>
                                <div className="fieldWrap mb-3">
                                    <label className="labelForm">
                                    PAN Card Image* 
                                    {/* <small className="labelBadge">Mandatory</small> */}
                                    </label>
                                    <div className="imageUpload-row">
                                    <div className="imageUpload-file">
                                        <div className="imgWrap">
                                        {service?.uploadPancard && <img src={service?.uploadPancard} alt="pancard" />}
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </li>
                        )
                    }

                    {
                        service?.serviceOfferedId?.serviceName !== "Others" && (
                            <li>
                                <div className="fieldWrap mb-3">
                                    <label className="labelForm">
                                    Skills 
                                    {/* <span>(Choose multiple)</span> */}
                                    </label>
                                    <div className="tagWrap ">
                                    {
                                        service.skills.map(skill => {
                                            return skill.skillname ? <div key={skill.skillName} className="tagBox">{skill.skillname} </div> : null
                                        })
                                    }
                                    </div>
                                </div>
                            </li>
                        )
                    }
                </ul>
                </div>
                {
                    showLevelRates ? (
                        <div className="fieldSet">
                            <h2 className="mb-3 titleText">
                                Rates
                                    {
                                        !isCopyEditing && (
                                            <ToolTip placement="top" toolTipMessage={rateMsg()}>
                                                <a class="infoMark">i</a>
                                            </ToolTip>
                                        )
                                    }
                            </h2>
                            <div className="anotherService pt-2">
                                <div className="anotherService-col">
                                    <label className="styledCheck">
                                        <input type="checkbox" checked={isRateChecked('rates')} disabled />
                                        {showRates && <><span>Designs using copyright free images, symbols and/or graphics.</span></>}
                                    </label>
                                    {
                                        isRateChecked('rates') ? (
                                            <ul className="rateList px-5 ps-0">
                                                {rateRecords('rates')}
                                            </ul>
                                        ) : <p className="mt-3">No rates found.</p>
                                    }
                                </div>
                                {isCopyEditing ? renderWorkSamples() : null}

                                {
                                    showRates ? (
                                        <div className="anotherService-col">
                                            <label className="styledCheck">
                                                <input type="checkbox" checked={isRateChecked('useOfOriginal')} disabled />
                                                <span>Designs using original Illustration/Symbols/Graphics (Freehand)</span>
                                            </label>
                                            {
                                                isRateChecked('useOfOriginal') ? (
                                                    <ul className="rateList px-5 ps-0">
                                                        {rateRecords('useOfOriginal')}
                                                    </ul>
                                                ) : <p className="mt-3">No rates found.</p>
                                            }
                                        </div>
                                    ) : null
                                }

                            </div>
                        </div>
                    ) : null
                }

                {(showRates && service.serviceOfferedId.serviceName != 'Book Cover Design') ? (
                    <div className="fieldSet">
                        <div className="anotherService pt-2">
                            <div className="anotherService-col">
                                <label className="styledCheck">
                                    <input type="checkbox" checked={isRateChecked('tableDesign')} disabled />
                                    <span>Table Design</span>
                                </label>
                                {
                                    isRateChecked('tableDesign') ? (
                                        <ul className="rateList px-5 ps-0">
                                            {rateRecords('tableDesign')}
                                        </ul>
                                    ) : <p className="mt-3">No rates found.</p>
                                }
                            </div>
                            <div className="anotherService-col">
                                <label className="styledCheck">
                                    <input type="checkbox" checked={isRateChecked('formulae')} disabled />
                                    <span>Formulae</span>
                                </label>
                                
                                {
                                    isRateChecked('formulae') ? (
                                        <ul className="rateList px-5 ps-0">
                                            {rateRecords('formulae')}
                                        </ul>
                                    ) : <p className="mt-3">No rates found.</p>
                                }
                            </div>
                        </div>
                    </div>
                ) : null}


                { showRates ? (
                    <div className="fieldSet">
                        <div className="anotherService pt-2">
                            {renderWorkSamples()}
                        </div>
                    </div>
                ) : null}
            </div>

            <div className="modal fade" id={"sampleViewModal" + service._id} tabIndex={service._id}>
                <div className={`modal-dialog modal-dialog-centered ${(fullScreen.type === 'image') ? 'modal-xl' : 'modal-bg'}`}>
                    <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">View Samples</h5>
                        <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        onClick={(e) => setFullScreen({show: false, url: '', type: 'image'}) }
                        aria-label="Close"
                        />
                    </div>
                    <div className="modal-body">
                        {(fullScreen.url && fullScreen.show) ? (
                            <div className="fullScreen-data">
                                {fullScreen.type === 'url' ? <p>{fullScreen.url}</p> : <img src={fullScreen.url} alt="image" />}
                            </div>

                        ) : <>
                            <div className="px-2 ps-0">
                            <div className="row">
                                {popupSamples()}
                                {workUrls()}
                            </div>
                            </div>
                        </>}
                    </div>
                    </div>
                </div>
            </div>
        </>

    )
}

export default ServiceDetails;